


















import Buildings from "./Buildings.vue";
import Filters from "./Filters.vue";
import SpaceHex from "./SpaceHex.vue";

export default {
  components: {
    Buildings,
    Filters,
    SpaceHex,
  },
};
